import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { map } from 'rxjs/operators';
import { KeyValue } from '@angular/common';
import { Cacheable } from 'ngx-cacheable';
import { CapacityObject } from '../api/src/app/models/REGBP-V1.0.0/capacity-object.model';

@Injectable({
  providedIn: 'root'
})
export class CapacityFacade {

  constructor(public regbpService: RegbpService) {}

  private getCapacitiesByType(type: string, language: string): Observable<KeyValue<string, string>[]> {
    return this.getCapacities(language).pipe(
      map((results: CapacityObject[]) =>
        results
          .filter((capacityObject: CapacityObject) => {
            return capacityObject.type === type;
          })
          .sort((a, b) => (+a.code > +b.code ? 1 : +b.code > +a.code ? -1 : 0))
          .map((capacityObject: CapacityObject) => {
            return {
              key: capacityObject.id.toString(),
              value: capacityObject.value
            };
          })
      )
    );
  }
  @Cacheable({ maxCacheCount: 3 })
  private getCapacities(language: string): Observable<CapacityObject[]> {
    return this.regbpService.getCapacitiesList(language).pipe(map((results: any) => results.$response.body.values));
  }
  public getCapacitiesGoods(language: string): Observable<KeyValue<string, string>[]> {
    return this.getCapacitiesByType('GOOD', language);
  }

  public getCapacitiesPersons(language: string): Observable<KeyValue<string, string>[]> {
    return this.getCapacitiesByType('PERSON', language);
  }
}
